import React from 'react';
import { motion } from 'framer-motion';
import Image1 from '../assets/img/ongo/Project2.webp'
import Image2 from '../assets/img/ongo/Project1.webp'
import Image3 from '../assets/img/ongo/Project.webp'
import CoverImage from '../assets/img/About/Image2.webp'
import Contact from '../pages/Contact'

// Animation Variant for individual project
const fadeInVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: 'easeOut',
    },
  }),
};

// Animation Variant for the whole section
const sectionVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut',
    },
  },
};

const projects = [
  {
    title: 'Children Education Support Program',
    description:
      'We support children from vulnerable families in Bole Sub City by providing school fees, uniforms, transport, food, medical aid, sanitary supplies, and educational materials. Our goal is to improve their academic focus and well-being.',
    image: Image1,
  },
  {
    title: 'Elders Support Program',
    description:
      'Our elders program offers monthly food provisions, medical assistance, and care for HIV/AIDS-affected guardians. We aim to enhance their dignity and quality of life.',
    image: Image3,
  },
  {
    title: 'Women Empowerment & Family Income Generation',
    description:
      'We provide skill-based training and micro-loans to mothers and caregivers. So far, 15 women have started small businesses, growing self-sufficient and improving family livelihoods.',
    image: Image2,
  },
];

const Ourproject = () => {
  return (
    <>
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center h-[60vh] md:h-[80vh] text-white flex items-center justify-center"
        style={{
          backgroundImage: `url(${CoverImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top',
          backgroundRepeat: 'no-repeat',
        }}

      >
        <div className="bg-black bg-opacity-60 absolute inset-0" />
        <div className="relative z-10 text-center px-4 ">
          <h1 className="text-3xl md:text-4xl lg:text-4xl font-bold uppercase mt-4 p-4 tracking-wider inline-block font-playfair animate-fade-up">Our Projects</h1>
          <p className="text-xl md:text-2xl font-light uppercase mt-2 tracking-wider font-playfair animate-fade-up">
            Transforming lives through love, support, and empowerment.
          </p>
        </div>
      </section>

      {/* Projects Section */}
      <motion.section
        className="md:py-16 py-8 px-4 bg-gray-50"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={sectionVariant}
      >
        <div className="mx-auto flex flex-col lg:flex-col justify-center items-center w-[90%] lg:w-[70%] gap-12 relative z-10">
          <div className="w-full space-y-6">
          <p className="text-sm text-[#90444D] font-semibold uppercase font-playfair tracking-wider">
              What we do
            </p>
            <h2 className="text-2xl md:text-3xl font-bold font-playfair text-gray-900 tracking-wider">
              Explore the impactful programs <br />
              we run to make a difference in the lives of<br />
              <span className="uppercase text-[#90444D]">Children & Elders</span>
            </h2>
          </div>

          <div className="space-y-16 w-full">
            {projects.map((project, index) => (
              <motion.div
                key={index}
                className={`flex flex-col md:flex-row items-center gap-8 md:gap-14 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={index}
                variants={fadeInVariant}
              >
                <div className="md:w-1/2 rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-500">
                  <div className="overflow-hidden rounded-t-2xl">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-64 md:h-72 object-cover object-top transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                </div>

                <div className="md:w-1/2 text-center md:text-left px-4">
                  <h3 className="text-3xl text-[#90444D] font-playfair  font-extrabold text-[#121C3D] mb-4">
                    {project.title}
                  </h3>
                  <p className="text-green-800 text-lg leading-relaxed">
                    {project.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
      <section>
        <Contact/>
      </section>
    </>
  );
};

export default Ourproject;
